const dateParts = value => {
  if (!value) return null;
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) return null;

  return { year, month, day, date };
};

export const formatJapaneseGregorianDate = value => {
  const parts = dateParts(value);
  if (!parts) return value ? String(value) : '';
  return `${parts.year}年${parts.month}月${parts.day}日`;
};

export const formatEnglishGregorianDate = value => {
  const parts = dateParts(value);
  if (!parts) return value ? String(value) : '';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC'
  }).format(parts.date);
};

export const formatNumericGregorianDate = value => {
  const parts = dateParts(value);
  if (!parts) return value ? String(value) : '';
  return `${parts.year}/${parts.month}/${parts.day}`;
};
